<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div id="announce" aria-atomic="true" class="container" role="alert">
    <div class="message">
        <span id="snack-bar-message">{{config.message}}</span>
    </div>
    <div class="action">
        <button id="action-button" mat-stroked-button *ngIf="config.action" (click)="dismiss()">{{config.action}}</button>
    </div>

    <span tabindex="-1" class="assistive-text">{{ "snackbar.autoclose" | translate }}</span>
</div>
